export type FaviconVariant = 'local' | 'prod';

const FAVICON_PATHS: Record<FaviconVariant, string> = {
  local: 'favicon-local.svg',
  prod: 'favicon.svg',
};

function isLocalhost(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';
}

export function resolveFaviconVariant(): FaviconVariant {
  return isLocalhost(window.location.hostname) ? 'local' : 'prod';
}

export function applyEnvironmentFavicon(): void {
  const href = FAVICON_PATHS[resolveFaviconVariant()];

  let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }

  link.type = 'image/svg+xml';
  link.href = href;
}
